import { render, staticRenderFns } from "./props.vue?vue&type=template&id=5c3db26a&scoped=true"
import script from "./props.vue?vue&type=script&lang=js"
export * from "./props.vue?vue&type=script&lang=js"
import style0 from "./props.vue?vue&type=style&index=0&id=5c3db26a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3db26a",
  null
  
)

export default component.exports